import type React from "react";
import { ReactComponent as Svg } from "./assets/check-1.svg";
import * as styles from "./Icon.module.scss";

type CheckProps = React.SVGProps<SVGSVGElement>;

export const Check = ({ className, ...props }: CheckProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
